<mat-card class="delivery-details-card">

    <mat-card-header>
        <mat-card-title>Delivery Details</mat-card-title>
    </mat-card-header>

    <mat-card-content>

        <table class="details-table">
            <tr>
                <td><strong>Date</strong></td>
                <td [title]="emailResponse?.Date">{{ emailResponse?.Date }}</td>
            </tr>
            <tr>
                <td><strong>Country</strong></td>
                <td [title]="emailResponse?.Country">{{ emailResponse?.Country }}</td>
            </tr>
            <tr>
                <td><strong>Account ID</strong></td>
                <td [title]="emailResponse?.AccountId">{{ emailResponse?.AccountId }}</td>
            </tr>
            <tr>
                <td><strong>Account Name</strong></td>
                <td [title]="emailResponse?.AccountName">{{ emailResponse?.AccountName }}</td>
            </tr>
            <tr>
                <td><strong>Contact Name</strong></td>
                <td [title]="emailResponse?.ContactName">{{ emailResponse?.ContactName }}</td>
            </tr>
            <tr>
                <td><strong>Email</strong></td>
                <td [title]="emailResponse?.CustomerContactEmail">{{ emailResponse?.CustomerContactEmail }}</td>
            </tr>
            <tr>
                <td><strong>Notification Title</strong></td>
                <td [title]="emailResponse?.NotificationTitle">{{ emailResponse?.NotificationTitle }}</td>
            </tr>
            <tr>
                <td><strong>Notification Type</strong></td>
                <td [title]="emailResponse?.NotificationType">{{ emailResponse?.NotificationType }}</td>
            </tr>
            <tr>
                <td><strong>Delivery Failure Reason</strong></td>
                <td [title]="emailResponse?.DeliveryFailedReason">{{ emailResponse?.DeliveryFailedReason }}</td>
            </tr>
            <tr>
                <td><strong>Delivery Failure description</strong></td>
                <td [title]="emailResponse?.DeliveryFailureDescription">{{ emailResponse?.DeliveryFailureDescription }}</td>
            </tr>
            <tr>
                <td><strong>Delivery details</strong></td>
                <td [title]="emailResponse?.DeliveryDetails">{{ emailResponse?.DeliveryDetails }}</td>
            </tr>
            <tr>
                <td><strong>Delivery Status</strong></td>
                <td>
                    <div [ngClass]="{ deliveredColor: emailResponse.DeliveryStatus === 'Delivered', failedColor: emailResponse.DeliveryStatus === 'Failed' }" class="chip" [title]="emailResponse.DeliveryStatus === 'Delivered'? 'Delivered' : 'Failed' ">
                        {{ emailResponse.DeliveryStatus }}
                    </div>
                </td>
            </tr>
            <tr>
                <td><strong>Resend</strong></td>
                <td>
                    <div *ngIf="emailResponse.IsResend === true" style="background-color: #ffb6c1; font-weight: bold;" [title]="'Yes'" class="chip">
                        Yes
                    </div>
                    <div *ngIf="emailResponse.IsResend === false" style="background-color: #ddd9d5; font-weight: bold;" [title]="'No'" class="chip">
                        No
                    </div>
                </td>
            </tr>
        </table>

    </mat-card-content>
  
    <mat-card-actions align="end">
        <button mat-flat-button color="primary" (click)="close()">Close</button>
    </mat-card-actions>

</mat-card>